/* GameFreudee reusable product row slider.
   Idempotent: runs once per page, inits each .gfr-slider once (safe with many instances). */
(function () {
  if (window.__gfrInit) return;
  window.__gfrInit = true;

  function initSlider(slider) {
    if (slider.dataset.gfrReady) return;
    slider.dataset.gfrReady = '1';

    /* data-gfr-shuffle: Karten pro Seitenbesuch durchmischen (Fisher-Yates).
       Muss vor der Indikator-/Breiten-Berechnung passieren. */
    if (slider.hasAttribute('data-gfr-shuffle')) {
      var cards = Array.prototype.slice.call(slider.children);
      for (var s = cards.length - 1; s > 0; s--) {
        var r = Math.floor(Math.random() * (s + 1));
        var tmp = cards[s]; cards[s] = cards[r]; cards[r] = tmp;
      }
      cards.forEach(function (c) { slider.appendChild(c); });
    }

    var isDown = false, startX, scrollLeft, scrollStartTime, velocityX = 0, momentumID;
    var sensitivity = 1.2;
    var container = slider.closest('.gfr-slider-container');
    if (!container) return;
    var prevButton = container.querySelector('.gfr-nav-button.gfr-prev');
    var nextButton = container.querySelector('.gfr-nav-button.gfr-next');

    var indicatorsContainer = document.createElement('div');
    indicatorsContainer.className = 'gfr-scroll-indicators';
    container.appendChild(indicatorsContainer);

    var firstCard = slider.querySelector('a');
    if (!firstCard) return;
    var cardWidth = firstCard.offsetWidth + (parseFloat(getComputedStyle(slider).columnGap) || 16);
    var visibleCards = Math.floor(slider.offsetWidth / cardWidth) || 1;
    var totalCards = slider.querySelectorAll('a').length;
    var pageCount = Math.ceil(totalCards / visibleCards);

    for (var i = 0; i < pageCount; i++) {
      (function (idx) {
        var indicator = document.createElement('span');
        indicator.className = 'gfr-scroll-indicator';
        indicatorsContainer.appendChild(indicator);
        indicator.addEventListener('click', function () {
          slider.scrollTo({ left: idx * slider.offsetWidth, behavior: 'smooth' });
        });
      })(i);
    }

    function updateIndicators() {
      var activeIndex = Math.min(pageCount - 1, Math.round(slider.scrollLeft / (visibleCards * cardWidth)));
      var indicators = indicatorsContainer.querySelectorAll('.gfr-scroll-indicator');
      indicators.forEach(function (ind, j) {
        ind.classList.toggle('active', j === activeIndex);
      });
      if (prevButton) {
        prevButton.disabled = slider.scrollLeft <= 0;
        prevButton.style.opacity = slider.scrollLeft <= 0 ? '0.5' : '1';
      }
      if (nextButton) {
        var maxScrollLeft = slider.scrollWidth - slider.offsetWidth;
        nextButton.disabled = slider.scrollLeft >= maxScrollLeft - 10;
        nextButton.style.opacity = slider.scrollLeft >= maxScrollLeft - 10 ? '0.5' : '1';
      }
    }

    function applyMomentum() {
      if (Math.abs(velocityX) < 0.5) { cancelAnimationFrame(momentumID); return; }
      slider.scrollLeft += velocityX;
      velocityX *= 0.95;
      momentumID = requestAnimationFrame(applyMomentum);
    }

    slider.addEventListener('scroll', updateIndicators);

    slider.addEventListener('mousedown', function (e) {
      isDown = true; slider.style.cursor = 'grabbing'; slider.classList.add('sliding');
      startX = e.pageX - slider.offsetLeft; scrollLeft = slider.scrollLeft;
      scrollStartTime = Date.now(); velocityX = 0; cancelAnimationFrame(momentumID); e.preventDefault();
    });
    slider.addEventListener('mouseleave', function () {
      if (isDown) { isDown = false; slider.style.cursor = 'grab'; slider.classList.remove('sliding');
        if (Date.now() - scrollStartTime < 100) applyMomentum(); }
    });
    slider.addEventListener('mouseup', function () {
      isDown = false; slider.style.cursor = 'grab'; slider.classList.remove('sliding');
      if (Date.now() - scrollStartTime < 100) applyMomentum();
    });
    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - slider.offsetLeft;
      var walk = (x - startX) * sensitivity;
      slider.scrollLeft = scrollLeft - walk;
      velocityX = (scrollLeft - slider.scrollLeft) / sensitivity;
      scrollStartTime = Date.now(); e.preventDefault();
    });

    slider.addEventListener('touchstart', function (e) {
      isDown = true; slider.classList.add('sliding');
      startX = e.touches[0].pageX - slider.offsetLeft; scrollLeft = slider.scrollLeft;
      scrollStartTime = Date.now(); velocityX = 0; cancelAnimationFrame(momentumID);
    }, { passive: true });
    slider.addEventListener('touchend', function () {
      if (isDown) { isDown = false; slider.classList.remove('sliding');
        if (Date.now() - scrollStartTime < 100) applyMomentum(); }
    });
    slider.addEventListener('touchmove', function (e) {
      if (!isDown) return;
      var x = e.touches[0].pageX - slider.offsetLeft;
      var walk = (x - startX) * sensitivity;
      var touchDeltaX = Math.abs(x - startX);
      var touchDeltaY = Math.abs(e.touches[0].pageY - e.touches[0].clientY);
      if (touchDeltaX > touchDeltaY * 1.5) {
        e.preventDefault();
        slider.scrollLeft = scrollLeft - walk;
        velocityX = (scrollLeft - slider.scrollLeft) / sensitivity;
        scrollStartTime = Date.now();
      }
    }, { passive: false });

    if (prevButton && nextButton) {
      var scrollAmount = visibleCards * cardWidth;
      prevButton.addEventListener('click', function () { slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' }); });
      nextButton.addEventListener('click', function () { slider.scrollBy({ left: scrollAmount, behavior: 'smooth' }); });
    }

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { slider.scrollBy({ left: -100, behavior: 'smooth' }); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { slider.scrollBy({ left: 100, behavior: 'smooth' }); e.preventDefault(); }
    });

    updateIndicators();
  }

  function initAll() {
    document.querySelectorAll('.gfr-slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
